import styled from "styled-components";

export default styled.section`
  max-width: 1240px;
  margin: 0 auto;
`;
